<wk-icon-close-sprite-pds3 />
<wk-icon-filled-check-circle-sprite-pds3 />
<wk-icon-filled-stop-sign-sprite-pds3 />
<wk-icon-filled-stop-sign-sprite-pds3 />

@if (model.typeLayout === "SUCCESS") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    slideDirection="right"
                    [isOpen]="item.isOpen"
                    [autoCloseTimeoutMS]="5000"
                    type="success"
                >
                    <div *notificationHeadingPds3>{{ "NotifyMessages.SuccessfullySavedHeading" | translate }}</div>
                    <span *notificationContentPds3>{{ "NotifyMessages.SuccessfullySaved" | translate }}</span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "ERROR") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    slideDirection="right"
                    [isOpen]="item.isOpen"
                    [autoCloseTimeoutMS]="null"
                    type="error"
                >
                    <div *notificationHeadingPds3>
                        @switch (model.messageCode) {
                            @case ("cannotSaveChanges") {
                                {{ "Error.CannotSaveChanges" | translate }}
                            }
                            @case ("400Error") {
                                {{ "Error.Service.400" | translate }}
                            }
                            @case ("404Error") {
                                {{ "Error.Service.404" | translate }}
                            }
                            @case ("409ErrorUniqueEmail") {
                                {{ "Error.UniqueFieldEmail" | translate }}
                            }
                            @case ("429TooManyRequests") {
                                {{ "Error.Service.429" | translate }}
                            }
                            @case ("500Error") {
                                {{ "Error.Service.500" | translate }}
                            }
                            @case ("defaultError") {
                                {{ "Error.Service.default" | translate }}
                            }
                            @case ("CancelSaved") {
                                {{ "NotifyMessages.CancelSavedHeading" | translate }}
                            }
                            @case ("microserviceGeneralError") {
                                {{ "Error.MicroServiceError" | translate }}
                            }
                            @case ("ErrorConnexionLost") {
                                {{ "Error.ConnexionLost" | translate }}
                            }
                        }
                    </div>
                    <span *notificationContentPds3>
                        @switch (model.messageCode) {
                            @case ("cannotSaveChanges") {
                                {{ "Error.CannotSaveChanges" | translate }}
                            }
                            @case ("400Error") {
                                {{ "Error.Service.400" | translate }}
                            }
                            @case ("404Error") {
                                {{ "Error.Service.404" | translate }}
                            }
                            @case ("409ErrorUniqueEmail") {
                                {{ "Error.UniqueFieldEmail" | translate }}
                            }
                            @case ("429TooManyRequests") {
                                {{ "Error.Service.429" | translate }}
                            }
                            @case ("500Error") {
                                {{ "Error.Service.500" | translate }}
                            }
                            @case ("defaultError") {
                                {{ "Error.Service.default" | translate }}
                            }
                            @case ("CancelSaved") {
                                {{ "NotifyMessages.CancelSaved" | translate }}
                            }
                            @case ("microserviceGeneralError") {
                                {{ "Error.MicroServiceError" | translate }}
                            }
                            @case ("ErrorConnexionLost") {
                                {{ "Error.ConnexionLost" | translate }}
                            }
                            @case ("UpdateTrackingCardError") {
                                {{ "NotifyMessages.DefaultCardSaveErrorContent" | translate }}
                            }
                            @case ("UpdateTrackingWithIFirmCardError") {
                                {{ "NotifyMessages.DefaultCardWithIFirmSaveErrorContentBeforeLink" | translate }}
                                <a target="_blank" href="{{ 'NotifyMessages.DefaultCardWithIFirmSaveErrorContentLinkUrl' | translate }}">{{
                                    "NotifyMessages.DefaultCardWithIFirmSaveErrorContentLinkText" | translate
                                }}</a>
                                {{ "NotifyMessages.DefaultCardWithIFirmSaveErrorContentAfterLink" | translate }}
                            }
                            @case ("UpdateIFirmTaxprepError") {
                                {{ "NotifyMessages.DefaultIFirmTaxprepSaveErrorContent" | translate }}
                            }
                            @case ("UpdateContactsError") {
                                {{ "NotifyMessages.DefaultContactsSaveErrorContent" | translate }}
                            }
                            @case ("UpdateJobError") {
                                {{ "NotifyMessages.DefaultJobSaveErrorContent" | translate }}
                            }
                        }
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "ALERT") {
    @if (model.messageCode !== "hiddenCards" && model.messageCode !== "hiddenJobsCards") {
        <div [attr.class]="'notification-story1'">
            <notification-toast-container-pds3 position="top-right">
                @for (item of notifications; track item.id) {
                    <notification-pds3
                        (close)="handleUserRequest(false, item.id)"
                        slideDirection="right"
                        [isOpen]="item.isOpen"
                        [autoCloseTimeoutMS]="null"
                        type="warning"
                    >
                        <div *notificationHeadingPds3>
                            {{
                                (model.messageCode === "dragDisabledTooManyColumns"
                                    ? "NotifyMessages.DragDisabledTooManyColumnsTitle"
                                    : "NotifyMessages.AlertHeading"
                                ) | translate
                            }}
                        </div>
                        <span *notificationContentPds3>
                            @switch (model.messageCode) {
                                @case ("CancelSaved") {
                                    {{ "NotifyMessages.CancelSaved" | translate }}
                                }
                                @case ("SignalRErrorDisconnect") {
                                    {{ "SignalRError.disconnect" | translate }}
                                }
                                @case ("dragDisabledTooManyColumns") {
                                    {{ "NotifyMessages.DragDisabledTooManyColumnsContent" | translate }}
                                }
                            }
                        </span>
                    </notification-pds3>
                }
            </notification-toast-container-pds3>
        </div>
    } @else {
        @let isJobsBillingDashboard = model.messageCode === "hiddenJobsCards";
        @let sectionKey = isJobsBillingDashboard ? "HiddenJobsCards" : "HiddenCards";
        @let singularSuffix = model.additionInfo === 1 ? "Singular" : "";
        <div [attr.class]="'notification-story1'">
            <notification-toast-container-pds3 position="top-right">
                @for (item of notifications; track item.id) {
                    <notification-pds3
                        notificationRole="status"
                        slideDirection="right"
                        (close)="handleUserRequest(false, item.id)"
                        [isOpen]="item.isOpen"
                        [autoCloseTimeoutMS]="null"
                        type="warning"
                    >
                        <div *notificationHeadingPds3>{{ `Error.${sectionKey}.Title${singularSuffix}` | translate }}</div>
                        <span *notificationContentPds3>
                            {{ `Error.${sectionKey}.NumberOfCardsNotVisible` | translate }}
                            {{ model.additionInfo }}
                            <pre></pre>
                            <span>
                                {{ "Error.HiddenCards.BeforLinkText" | translate }}
                                <a target="_blank" href="{{ 'Error.HiddenCards.QuestionsLink' | translate }}">{{
                                    "Error.HiddenCards.LinkText" | translate
                                }}</a>
                                {{ `Error.${sectionKey}.AfterLinkText${singularSuffix}` | translate }}
                            </span>
                        </span>
                    </notification-pds3>
                }
            </notification-toast-container-pds3>
        </div>
    }
} @else if (model.typeLayout === "EXPORT-SUCCESS") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    slideDirection="right"
                    [isOpen]="item.isOpen"
                    [autoCloseTimeoutMS]="5000"
                    type="success"
                >
                    <div *notificationHeadingPds3>{{ (model.messageCode === "csv" ? "Export.CsvTitle" : "") | translate }}</div>
                    <span *notificationContentPds3>
                        <span>{{ "Export.Success" | translate }}</span>
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "EXPORT-ERROR") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    [isOpen]="item.isOpen"
                    slideDirection="right"
                    [autoCloseTimeoutMS]="null"
                    type="error"
                >
                    <div *notificationHeadingPds3>{{ (model.messageCode === "csv" ? "Export.CsvTitle" : "") | translate }}</div>
                    <span *notificationContentPds3>
                        <span> {{ "Export.Fail" | translate }}</span>
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "DELETE-SUCCESS") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    [isOpen]="item.isOpen"
                    slideDirection="right"
                    [autoCloseTimeoutMS]="5000"
                    type="success"
                >
                    <div *notificationHeadingPds3>{{ "NotifyMessages.SuccessfullySavedHeading" | translate }}</div>
                    <span *notificationContentPds3>
                        <span>{{ model.additionInfo }}</span>
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "DELETE-ERROR") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    slideDirection="right"
                    [isOpen]="item.isOpen"
                    [autoCloseTimeoutMS]="null"
                    type="error"
                >
                    <div *notificationHeadingPds3>{{ "NotifyMessages.CancelSavedHeading" | translate }}</div>
                    <span *notificationContentPds3>
                        <span>{{ model.additionInfo }}</span>
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
} @else if (model.typeLayout === "FILTER-SAVE-ERROR") {
    <div [attr.class]="'notification-story1'">
        <notification-toast-container-pds3 position="top-right">
            @for (item of notifications; track item.id) {
                <notification-pds3
                    (close)="handleUserRequest(false, item.id)"
                    slideDirection="right"
                    [isOpen]="item.isOpen"
                    [autoCloseTimeoutMS]="null"
                    type="error"
                >
                    <div *notificationHeadingPds3>{{ "NotifyMessages.CancelSavedHeading" | translate }}</div>
                    <span *notificationContentPds3>
                        <span>{{ model.additionInfo }}</span>
                    </span>
                </notification-pds3>
            }
        </notification-toast-container-pds3>
    </div>
}
